const baseUrl = window.location.protocol +"//"+ window.location.hostname+":6002";

export const endpoints = {
    login: baseUrl +'/login',
    resources: baseUrl +'/api/resources',
    monitored_houses: baseUrl +'/api/monitored_houses',
    incidents: baseUrl +'/api/incidents',
    resources_services: baseUrl +'/api/resources_services',
    metrics: baseUrl +'/api/metrics',
    meanMetrics: baseUrl +'/api/mean-metrics'
}

export enum MonthLongStrings {
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
}

export enum Severity {
    Default= "",
    High = "1 - High",    
    Medium = "2 - Medium High",
    Low = "3 - Medium,4 - Medium Low,5 - Low"    
}

export enum Metrics {
    Default= "",
    Temperature = "High Temperature,Low Temperature",
    Humidity = "High Humidity,Low Humidity",
    AirQuality = "High CO2 Levels,High Gas&Smoke,CO2",
    Inactivity = "Suspicious Activity,Movement",
    Illuminance = "Illuminance",
    Noise = "Noise",
    Energy = "Energy"
}